// extracted by css-extract-rspack-plugin
export default {"frame":"frame-IYfniQ","frameMain":"frameMain-YaoJ65","frameMainIsCollapsed":"frameMainIsCollapsed-G6QYzd"};